import type { LocalStorageFunctions, LocalFirstTime } from './types';

const FIRST_TIME: string = 'first-time-flag';

const getLocalStorageFirstTime = (fn: LocalStorageFunctions) => (): boolean => !!fn.readObject(FIRST_TIME);
const setLocalStorageFirstTime = (fn: LocalStorageFunctions) => () => fn.writeObject(FIRST_TIME, true);

const firstTime = (fn: LocalStorageFunctions): LocalFirstTime => ({
  getLocalStorageFirstTime: getLocalStorageFirstTime(fn),
  setLocalStorageFirstTime: setLocalStorageFirstTime(fn)
});

export default firstTime;
